import { createValidation } from '_metronic/helpers'
import { TFunction } from '_metronic/i18n/Metronici18n'
import * as Yup from 'yup'

export const medicamentoSchema = (t: TFunction) => {
  const v = createValidation(t)

  return Yup.object({
    nome: Yup.string().required(v.requiredField('nome')),
    receituario: Yup.object().nullable().required(v.requiredField('receituario')),
    ativo: Yup.boolean().required(v.requiredField('situacao')),
  })
}
